import React from 'react'

import ValuePagesTemplate from '../components/ValuePagesTemplate'
import Text from '../components/Text'
import PageTitle from '../components/PageTitle'

const GrowthPage = () => (
  <ValuePagesTemplate>
    <PageTitle title='Growth Opportunities' />
    <Text>We want to work on projects that we believe give us the opportunity to become better people and better professionals.</Text>
    <Text>Growth is a choice, not a byproduct.</Text>
  </ValuePagesTemplate>
)

export default GrowthPage



// WEBPACK FOOTER //
// ./src/pages/growth-opportunities.js